import React from "react";
import { Flex } from "discover.medical.react-component-library";
import { HeaderContainer, Logo } from "./Header.styled";
import DMLogo from "../../assets/svg/dynamed-logo-white.svg";
import DMXLogo from "../../assets/svg/dynaMedex-logo.svg";

const Header = ({ productCode, productName }) => {
  const logo = productCode === "dmx" ? DMXLogo : DMLogo;

  return (
    <HeaderContainer>
      <Flex container align={{ item: "center" }} height="100%">
        <a href="/">
          <Logo src={logo} alt={productName} />
        </a>
      </Flex>
    </HeaderContainer>
  );
};

export default Header;
